"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const assets_1 = require("../../../api/assets");
const translation_1 = require("../../../common/js/helper/translation");
const Paths_1 = require("../../constants/Paths");
const DataLayerEvents_1 = __importDefault(require("../../enums/DataLayerEvents"));
const dataLayer_1 = require("../../helper/dataLayer");
const path_1 = require("../../helper/path");
class NotificationItem extends react_1.default.Component {
    render() {
        const { item } = this.props;
        const parameters = item.parameters ?? {};
        const text = (0, translation_1.t)('notifications.text', { subject: item.subject, ...parameters });
        const path = this.path(item);
        if (null === path) {
            return react_1.default.createElement("div", { className: "znd-notification-item" }, this.renderIconAndLabel(text));
        }
        return (react_1.default.createElement("a", { href: path, onClick: () => {
                (0, dataLayer_1.pushToDataLayer)({
                    event: DataLayerEvents_1.default.dlvClickNotification,
                    value: item.subject.valueOf(),
                });
            }, className: "znd-notification-item znd-notification-item--link" }, this.renderIconAndLabel(text)));
    }
    renderIconAndLabel(label) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { className: "znd-icon-info znd-notification-item__icon-info" }, "!"),
            react_1.default.createElement("span", { className: "znd-notification-item__label" }, label)));
    }
    path(item) {
        if (!!item.parameters?.licenseId) {
            return (0, path_1.localePath)(Paths_1.PATH_ASSETS_SOFTWARE_EXPANDED.replace(':softwareId', item.parameters.licenseId));
        }
        if (item.subject === assets_1.NotificationSubjectEnum.PendingInvoices) {
            return (0, path_1.localePath)(Paths_1.PATH_ASSETS_OFFER);
        }
        return null;
    }
}
__decorate([
    bind_decorator_1.default
], NotificationItem.prototype, "renderIconAndLabel", null);
exports.default = (0, react_i18next_1.withTranslation)()(NotificationItem);
